<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="changeReservationStatusModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień status magazynowy wybranych wierszy</h5>

            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>

            <div class="col-md-12">
              <label for="project-select">Wybierz status:</label>
              <select id="project-select" class="form-select form-select-sm" @change="updateSelectedStatus"
                      v-model="newSelectedStatus">
                <option v-for="status in statuses" :value="status"> {{ status }}</option>
              </select>
            </div>

            <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Zarezerwowana ilość</th>
                  <th>Wydana ilość</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in selectedRecords">
                  <td>{{ record?.article_catalog_number }}</td>
                  <td>{{ record?.article_model }}</td>
                  <td>{{ record?.article_description }}</td>
                  <td>{{ record.quantity_reserved }}</td>
                  <td>{{ record.fulfilled_quantity }}</td>
                  <td>{{ record.status }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>

            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {Modal} from "bootstrap";

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  props: {
    selectedRecords: Object,
    statuses: Array
  },

  data() {

    return {
      newSelectedStatus: null,
      isSubmitting: false,
      error: null,
    }
  },

  watch: {
    selectedRecords: {
      handler(newVal) {
        if (newVal && newVal.length) {
          // gdy dane przyjdą – odśwież modal
          this.newSelectedStatus = null
          this.error = null
        }
      },
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
		  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  methods: {
    updateSelectedStatus(event) {
      this.newSelectedStatus = event.target.value;
    },

    submitForm() {
      if (!this.selectedRecords[0]?.id) {
        console.log('brak wybranej rezerwacji');
        return;
      }

      this.isSubmitting = true;

      axios.patch(route('warehouse-reservations.update-status', {
            reservations: this.selectedRecords.map(record => ({id: record.id})), // tylko ID rezerwacji
            newStatus: this.newSelectedStatus
          }
      )).then(() => {
        this.$emit('status-updated-success', 'Zmieniono status poprawnie');
        this.$emit('refresh', true);
		this.$emit('clear-selection');
        this.hide();
      }).catch(error => {
        this.$emit('status-updated-error', 'Błąd przy zmianie statusu: ' + error.response.data);
        this.error = error.response.data
        console.log('error', error);
      }).finally(() => {
        this.isSubmitting = false;
      })
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>

<style scoped>

</style>